export default __webpack_public_path__ + "static/media/CNo.75-4.dfd0a857.jpg";